import {
  DeliveryAssignmentProviderEntity,
  Div,
  Icon,
  Img,
  lightTheme,
  renderVDriveIcon,
  VDriveProvider,
  X,
} from '@vgrubs/components';
import { Dispatch, SetStateAction } from 'react';

export const SelectedFallbackAssignmentProvider = ({
  provider,
  index,
  parentIndex,
  setProviders,
}: {
  provider: VDriveProvider;
  index: number;
  parentIndex: number;
  setProviders: Dispatch<SetStateAction<DeliveryAssignmentProviderEntity[]>>;
}) => {
  const handleDeleteFallback = () => {
    setProviders((prev) =>
      prev.map((p, i) =>
        i === parentIndex
          ? {
              ...p,
              fallbackProviders: p.fallbackProviders?.filter(
                (_, j) => j !== index
              ),
            }
          : p
      )
    );
  };

  return (
    <Div $flex $gap="2px">
      <Img
        alt=""
        src={renderVDriveIcon(provider)}
        $width="32px"
        $widthSM="32px"
      />
      <Icon $size="12" display="block" $pointer onClick={handleDeleteFallback}>
        <X fill={lightTheme.lightGray} />
      </Icon>
    </Div>
  );
};
